
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
import daifuordersubmit from './OrdersEdit.vue';
var that;
@Component({
  components: { daifuordersubmit }
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.MerchantPayOrderServiceProxy();
  }
  pageSize = 10
  input: proxy.PayOrderPageInputDto = new proxy.PayOrderPageInputDto();
  sub_id = 0;
  createOrEditShow = false;

  ordertotal={}
  comment = ''
  PayChannels = []
  createrange = [];
  successrange = [];
  // todaytotal = new proxy.QueryModelListTotalOutDto();
  // listtotal = new proxy.QueryModelListTotalOutDto();
  statustotal = []
  canceltimes = []
  merchantTypes = []

  options = {
    shortcuts: [
      {
        text: '今天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
          return [start, end]
        }
      },
      {
        text: '昨天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime());
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24);
          return [start, end]
        }
      },
      {
        text: '三天',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 2);
          return [start, end]
        }
      },
      {
        text: '一周',
        value() {
          const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000);
          const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 6);
          return [start, end]
        }
      }
    ]
  }

  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
      fixed: 'left',
    },

    {
      title: '单号',
      slot: 'tid',
      width: 300,
      fixed: 'left',
    },

    {
      title: '通道',
      slot: 'payChannelName',
      width: 200
    },
    {
      title: '金额',
      slot: 'money',
      width: 180
    },
    {
      title: '支付耗时',
      slot: 'payTimeConsuming',
      width: 150
    },
    {
      title: '订单状态',
      slot: 'payOrderStatusName',
      width: 150
    },
    {
      title: '是否冲正',
      slot: 'isCz',
      width: 110
    },
    // {
    //   title: '手续费',
    //   key: 'commission',
    //   width: 100
    // },
    {
      title: '通知状态',
      slot: 'noticeStatus',
      width: 120
    },

    //   {
    //     title: '通知次数',
    //     key: 'noticeCount',
    //     width: 100
    //   },
    {
      title: '创建时间',
      slot: 'creationTime',
      width: 180
    },
    {
      title: '成功时间',
      slot: 'successTime',
      width: 180
    },
    {
      title: '失败时间',
      key: 'failTime',
      width: 180
    },

    // {
    //   title: '操作',
    //   slot: 'opera',
    //   fixed: 'right',
    //   width: 200
    // }
  ];


  editsuccess(e) {
    if (e == 1) {
      let m = that.dataList.find(x => x.daiFuOrderType == 0 && (x.daiFuPay == 0 || x.daiFuPay == 2) && x.id < this.sub_id);
      if (m) {
        setTimeout(() => {
          this.daifusubmit(m);
        }, 200)
      }
    } else {

      this.getpage();
    }
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime =this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.input.successStartTime = this.successrange[0];
    this.input.successEndTime = this.successrange[1];
    this.input.cancelTimeStart = this.canceltimes[0];
    this.input.cancelTimeEnd = this.canceltimes[1];
    this.prox.queryModelList(this.input).then(x => {
      this.dataList = x.items;

      this.showPaging(x);
    });
    this.prox.queryMerchantOrderTotal(this.input).then(x=>
    {
        this.ordertotal = x;
    })
  }

  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    this.prox.export(this.input).then((x) => {
      location.href =
        AppConsts.remoteServiceBaseUrl +
        '/File/DownloadTempFile?FileToken=' +
        x.fileToken +
        '&fileName=' +
        x.fileName +
        '&fileType=' +
        x.fileType;
    });
  }

  getpage() {
    this.OnInit();
  }
  async created() {
    //this.createrange = [new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime()), new Date(new Date(this.formatDate(new Date(),'yyyy/MM/dd')).getTime() + 86400000)]
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    that = this;
    //   new proxy.PayChannelServiceProxy().queryAll().then(x => {
    //     this.PayChannels = x;
    //   })
    //   this.prox.queryTodayStatusTotal().then(x => {
    //     this.statustotal = JSON.parse(x)
    //   })
    //   setInterval(() => {
    //     this.prox.queryTodayStatusTotal().then(x => {
    //       this.statustotal = JSON.parse(x)
    //     })
    //   }, 15000)
    //   this.prox.queryTodayTotal().then(x => {
    //     this.todaytotal = x;
    //   })
    let creq = new proxy.ChannelTypePageInputDto();
    
    new proxy.MerchantClientServiceProxy().queryAllTypes(creq).then((x) => {
      this.merchantTypes = x;
    });
    this.getpage();
  }


  daifusubmit(row) {
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }

  del() {
    //   if (this.selectedDataItems.length == 0) {
    //     this.$Notice.error({ title: '请至少选中一条数据' });
    //     return;
    //   }
    //   this.$Modal.confirm({
    //     title: '你确定要删除吗?删除后将无法恢复',
    //     onOk: () => {
    //       var ids = this.selectedDataItems.map(x => {
    //         return x.id;
    //       });
    //       this.prox.deletes(ids).then(() => {
    //         this.$Notice.success({ title: '删除成功' });
    //         this.getpage();
    //       });
    //     }
    //   });
  }
}
